import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const Card = ({ imageSrc, title, headerClasses, description }) => {

  return (
    <div className={`${description && description.length > 0 ? 'bg-white shadow-md' : ''}
    w-full sm:basis-[calc(50%-0.5rem)] lg:basis-[calc(33.333%-0.75rem)] rounded-2xl ${description && description.length > 0 ? 'pb-12' : 'pb-4'} overflow-hidden`}>
      <img
        src={imageSrc}
        alt={title}
        className={`w-full h-40 object-cover ${!(description && description.length > 0) ? 'rounded-2xl' : ''}`}
      />

      <div className="px-4 py-4 pb-5 text-left">
        <p className={headerClasses}>{parse(title)}</p>
        {description && <div className="text-[#231F20] mt-2">{parse(description)}</div>}
      </div>
    </div>
  );
};

Card.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  headerClasses: PropTypes.string,
  description: PropTypes.string.isRequired,
};

export default Card;
